'use client';
import { useRoiFrame } from './use-roi-frame';

/**
 * "Back to Calculator": the live page's floating button (copy preserved word for word, found missing by the content walker).
 * Appears once the app frame has scrolled out of view and scrolls back to it. Restyled for the v2 page: a quiet ink pill (not the old
 * solid blue), bottom-LEFT so it never sits on the activity toasts (bottom-right); on phones it is an icon. It shows only once the calculator is off screen, and the phone run bar only while it is on screen, so the two never overlap.
 */
export function RoiBackToCalc() {
  const { past: show } = useRoiFrame();
  const go = () => {
    const el = frame2();
    if (!el) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 84, behavior: reduce ? 'auto' : 'smooth' });
  };
  return (
    <button type="button" onClick={go} aria-label="Back to Calculator" tabIndex={show ? 0 : -1} aria-hidden={!show} data-show={show ? '1' : '0'} className="rg-back">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2.5" /><path d="M8.5 7.5h7M9 12h.01M12 12h.01M15 12h.01M9 16h.01M12 16h.01M15 16h.01" /></svg>
      <span className="rg-back-t">Back to Calculator</span>
      <svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M10 16V4M5 9l5-5 5 5" /></svg>
    </button>
  );
}
function frame2() { return document.getElementById('roi-app'); }
